import React from 'react';

import Sponsorships from '../../../react4xp/components/Sponsorships'

function SponsorshipPart({ bgColor, image, tagline, title, text, cta }) {
    return (
        <Sponsorships
            bgColor={bgColor}
            img={image}
            subTitle={tagline}
            title={title}
            text={text}
            cta={cta}
        />
    )
}

export default (props) => <SponsorshipPart {...props} />
